import { useErrorNotificationApi } from '@equifinance/shared';
import { Credit, CreditItem, Insolvency } from '../contexts/credit';

const apiPath = `${process.env.REACT_APP_ORIGINATION_API_PATH}/`;

const apiUrl = (path: string) => `${apiPath}${path}`;

const useCreditApi = () => {
  const {
    del, put, get,
  } = useErrorNotificationApi(apiUrl);

  return {
    fetch: (id: string): Promise<Credit> => get(`searches/credit/${id}`),
    // update: (id: string, data: Credit): Promise<Credit> => put(`searches/credit/${id}`, data),
    update: (
      id: string,
      data: {
        securedCreditItems: Partial<CreditItem>[],
        unsecuredCreditItems: Partial<CreditItem>[],
        insolvencyRecords: Partial<Insolvency>[]
      },
    ): Promise<Credit> => put(`searches/credit/${id}`, data),
    del: (id: string, items: Record<string, string[]>): Promise<Credit> => del(`searches/credit/${id}`, items),
  };
};

export default useCreditApi;
